import { TcTrackPoint } from "../data/type";

const cache: Record<string, AMap.Polyline[]> = {};

export function connectPointsWithColoredLines(
  eventId: string,
  map: any,
  pointArray: TcTrackPoint[],
  isShowTcTrack: boolean,
) {
  if (!!cache[eventId] && cache[eventId].length) {
    map.add(cache[eventId]);
    return cache[eventId];
  }

  if (pointArray.length < 2) {
    return [];
  }

  const lines: any[] = [];

  // 创建每段线段，颜色根据起点颜色设置
  for (let i = 0; i < pointArray.length - 1; i++) {
    const startPoint = pointArray[i];
    const endPoint = pointArray[i + 1];

    // 使用起点的颜色
    const lineColor = startPoint.color;

    // 根据日期设置线段样式：过去用实线，将来用虚线
    const strokeStyle = startPoint.isForecast ? "dashed" : "solid";
    const strokeColor = startPoint.isForecast ? "#666" : lineColor;

    const polyline = new AMap.Polyline({
      path: [
        new AMap.LngLat(
          startPoint.geometry.coordinates[0],
          startPoint.geometry.coordinates[1]
        ),
        new AMap.LngLat(
          endPoint.geometry.coordinates[0],
          endPoint.geometry.coordinates[1]
        )
      ],
      strokeColor: strokeColor,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      strokeStyle: strokeStyle, // 设置线段样式
      lineJoin: "round",
      lineCap: "round",
      zIndex: 50
    });

    // 将折线添加到地图
    map.add(polyline);

    lines.push(polyline);
  }
  cache[eventId] = lines;

  if(!isShowTcTrack){
    hideLine(eventId);
  }
  return lines;
}

export function clearLine(eventId: string, map: any) {
  // 检查缓存中是否存在该事件的标记
  if (!cache[eventId] || !cache[eventId].length) {
    return;
  }

  // 从地图中移除所有标记
  map.remove(cache[eventId]);

  // 清除缓存
  delete cache[eventId];
}

export function hideLine(eventId: string) {
  // 检查缓存中是否存在该事件的标记
  if (!cache[eventId] || !cache[eventId].length) {
    return;
  }

  // 获取缓存的标记
  const markers = cache[eventId];
  
  markers.forEach(marker => {
    if (!marker.getMap()) {
      return;
    } 
    marker.hide();
  });
}

export function showAllLine() {
  // 遍历所有事件
  Object.keys(cache).forEach(eventId => {
    const markers = cache[eventId];
    
    if (markers && markers.length) {
      // 将标记添加到地图或使其可见
      markers.forEach(marker => {
        if (marker.getMap()) {
          marker.show();
        } else {
          // map.add(marker);
        }
      });
    }
  });
}

export function hideAllLine() {
  // 遍历所有事件
  Object.keys(cache).forEach(eventId => {
    const markers = cache[eventId];
    
    if (markers && markers.length) {
      // 隐藏标记
      markers.forEach(marker => {
        if (!marker.getMap()) {
          return;
        } 
        marker.hide();
      });
    }
  });
  
}
